<div style="margin: 10px 10px 10px 0px;">
  <h1>SNMP V3</h1>
  <form [formGroup]="SettingsForm" (ngSubmit)="applyTempChanges()">
    <div class="mb-3 row">
      <label for="name" class="col-lg-1 col-form-label">Name:</label>
      <div class="col-lg-4">
        <input id="name" type="text" class="form-control" [ngClass]="{'is-invalid':!Name.valid}" [formControl]="Name" />
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="IsDefault" [ngClass]="{'is-invalid': !IsDefault.valid}" />
        <span class="uv-checkbox-label">Default</span>
      </div>
    </div>
    <div class="form-group row">
      <label for="description" class="col-lg-1 col-form-label">Description:</label>
      <div class="col-lg-4">
        <input id="description" type="text" class="form-control" [ngClass]="{'is-invalid':!Description.valid}" [formControl]="Description" />
      </div>
    </div>
    @if (Name.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-5 alert alert-danger error-message">Name is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="username" class="col-lg-1 col-form-label">User Name:</label>
      <div class="col-lg-4">
        <input id="username" type="text" class="form-control" [ngClass]="{'is-invalid':!Username.valid}" [formControl]="Username" />
      </div>
      <label for="context" class="col-lg-1 col-form-label">Context:</label>
      <div class="col-lg-4">
        <input id="context" type="text" class="form-control" [ngClass]="{'is-invalid':!Context.valid}" [formControl]="Context" />
      </div>
    </div>
    @if (Username.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-5 alert alert-danger error-message">User Name is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="timeout" class="col-lg-2 col-form-label">Timeout (in milliseconds):</label>
      <div class="col-lg-2">
        <input form="timeout" type="number" class="form-control" [ngClass]="{'is-invalid':!Timeout.valid}" [formControl]="Timeout" />
      </div>
      <label for="retries" class="col-lg-1 col-form-label">Retries:</label>
      <div class="col-lg-2">
        <input id="retries" type="number" class="form-control" [ngClass]="{'is-invalid':!Retries.valid}" [formControl]="Retries" />
      </div>
    </div>
    @if (Timeout.hasError('required') || Timeout.hasError('minValue') || Timeout.hasError('maxValue') || Retries.hasError('required') || Retries.hasError('minValue') || Retries.hasError('maxValue')) {
      <div class="mb-3 row">
        @if (Timeout.hasError('required')) {
          <div class="col-lg-4 alert alert-danger error-message">Timeout is required</div>
        }
        @if (Timeout.hasError('minValue') || Timeout.hasError('maxValue')) {
          <div class="col-lg-4 alert alert-danger error-message">Timeout must be in the range 200 - 60000</div>
        }
        @if (Retries.hasError('required')) {
          <div class="col-lg-4 alert alert-danger error-message">Retries is required</div>
        }
        @if (Retries.hasError('minValue') || Retries.hasError('maxValue')) {
          <div class="col-lg-4 alert alert-danger error-message">Retries must be in the range 0 - 10</div>
        }
      </div>
    }
    <div class="mb-3 row">
      <label for="port" class="col-lg-2 col-form-label">Port:</label>
      <div class="col-lg-2">
        <input id="port" type="number" class="form-control" [ngClass]="{'is-invalid':!Port.valid}" [formControl]="Port" />
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="UseGetBulk" />
        <span class="uv-checkbox-label">Use Get-BULK</span>
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="IgnoreEngineBoots" />
        <span class="uv-checkbox-label">Ignore Engine Boots</span>
      </div>
    </div>
    @if (Port.hasError('required') || Port.hasError('minValue') || Port.hasError('maxValue')) {
      <div class="mb-3 row">
        @if (Port.hasError('required')) {
          <div class="col-lg-4 alert alert-danger error-message">Port is required</div>
        }
        @if (Port.hasError('minValue') || Port.hasError('maxValue')) {
          <div class="col-lg-4 alert alert-danger error-message">Port must be in the range 1 - 65535</div>
        }
      </div>
    }
    <fieldset>
      <legend>Authentication</legend>
      <div class="mb-3 row">
        <label for="snmpV3AuthProtocol" class="col-lg-1 col-form-label">Protocol:</label>
        <div class="col-lg-2">
          <select id="snmpV3AuthProtocol" class="form-control" [ngClass]="{'is-invalid':!AuthProtocol.valid}"
            [formControl]="AuthProtocol" (change)="enableDisableControls()">
            <option value="None">None</option>
            <option value="MD5">MD5</option>
            <option value="SHA1">SHA1</option>
            <option value="SHA256">SHA256</option>
            <option value="SHA384">SHA384</option>
            <option value="SHA512">SHA512</option>
          </select>
        </div>
      </div>
      <div class="mb-3 row">
        <label for="snmpV3AuthPassword" class="col-lg-1 col-form-label">Password:</label>
        <div class="col-lg-4">
          <input [type]="PasswordInputType" class="form-control" [formControl]="AuthPassword"
            id="snmpV3AuthPassword" [ngClass]="{'is-invalid':SettingsForm.hasError('authPasswordsEqual')}"
            (keydown)="onPasswordKeyDownHandler($event, 'AuthPassword')" />
          </div>
          <label for="snmpV3AuthPasswordConfirm" class="col-lg-1 col-form-label">Confirm:</label>
          <div class="col-lg-4">
            <input [type]="PasswordInputType" class="form-control" [formControl]="AuthPasswordConfirm"
              id="snmpV3AuthPasswordConfirm" [ngClass]="{'is-invalid':SettingsForm.hasError('authPasswordsEqual')}"
              (keydown)="onPasswordKeyDownHandler($event, 'AuthPassword')" />
            </div>
          </div>
          @if (SettingsForm.hasError('authPasswordsEqual')) {
            <div class="mb-3 row">
              <div class="col-lg-5 alert alert-danger error-message">Confirm must be the same as Password</div>
            </div>
          }
        </fieldset>
        <fieldset>
          <legend>Encryption</legend>
          <div class="mb-3 row">
            <label for="snmpV3EncryptProtocol" class="col-lg-1 col-form-label">Protocol:</label>
            <div class="col-lg-2">
              <select id="snmpV3EncryptProtocol" class="form-control" [ngClass]="{'is-invalid':!EncryptProtocol.valid}"
                [formControl]="EncryptProtocol" (change)="enableDisableControls()">
                <option value="None">None</option>
                <option value="DES">DES</option>
                <option value="AES128">AES128</option>
                <option value="AES192">AES192</option>
                <option value="AES256">AES256</option>
              </select>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="snmpV3EncryptPassword" class="col-lg-1 col-form-label">Password:</label>
            <div class="col-lg-4">
              <input [type]="PasswordInputType" class="form-control" [formControl]="EncryptPassword"
                id="snmpV3EncryptPassword" [ngClass]="{'is-invalid':SettingsForm.hasError('encryptPasswordsEqual')}"
                (keydown)="onPasswordKeyDownHandler($event, 'EncryptPassword')" />
              </div>
              <label for="snmpV3EncryptPasswordConfirm" class="col-lg-1 col-form-label">Confirm:</label>
              <div class="col-lg-4">
                <input [type]="PasswordInputType" class="form-control" [formControl]="EncryptPasswordConfirm"
                  id="snmpV3EncryptPasswordConfirm" [ngClass]="{'is-invalid':SettingsForm.hasError('encryptPasswordsEqual')}"
                  (keydown)="onPasswordKeyDownHandler($event, 'EncryptPassword')" />
                </div>
              </div>
              @if (SettingsForm.hasError('encryptPasswordsEqual')) {
                <div class="mb-3 row">
                  <div class="col-lg-5 alert alert-danger error-message">Confirm must be the same as Password</div>
                </div>
              }
            </fieldset>
            <div class="mb-3 row">
              <label for="snmpV3ShowChars" class="col-lg-1 col-form-label">&nbsp;</label>
              <div class="col-lg-2">
                <input id="snmpV3ShowChars" type="checkbox" [formControl]="ShowChars"
                  (change)="ToggleShowChars()" [ngClass]="{'is-invalid':!ShowChars.valid}" />
                  <span class="uv-checkbox-label">Show Chars</span>
                </div>
              </div>
              <div class="form-group row">
                <label for="ipscope" class="col-lg-1 col-form-label">IP Scope:</label>
                <div class="col-lg-4">
                  <textarea id="ipscope" rows="5" cols="50" class="form-control" [formControl]="IpScope"
                  [ngClass]="{'is-invalid': !IpScope.valid}"></textarea>
                </div>
              </div>
              <button type="submit" pButton [disabled]="!SettingsForm.valid || SettingsForm.pristine" label="Apply"></button>
            </form>
          </div>
